<template>
  <v-container fluid class="pa-0">
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              AMS Configuration
            </div>
          </div>
        </v-col>
        <v-col>
          <v-card-actions>
            <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
              <v-btn elevation="1" absolute right top>
                <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            </router-link>
          </v-card-actions>
        </v-col>
      </v-row>
      <v-row class="rowClass">
        <v-col cols="12" sm="6" md="4" lg="4" v-if="AMS_CycleConfiguration === true || isSuperAdmin === true">
          <router-link :to="{
            name: 'cycleConfiguration',

          }">
            <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-collage" color="red" style="max-width: 400px;" cardTitle="Cycle Configuration">
            </clickable-card>
          </router-link>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" v-if="AMS_WeightageModification === true || isSuperAdmin === true">
          <router-link :to="{
            name: 'weightageModification',

          }">
            <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-cogs" color="warning" style="max-width: 400px;"
              cardTitle="Weightage % Modification">
            </clickable-card>
          </router-link>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" v-if="AMS_ZonalManager === true || isSuperAdmin === true">
          <router-link :to="{
            name: 'centerFirstAudit',

          }">
            <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-garage" color="green" style="max-width: 400px;" cardTitle="Center 1st Audit">
            </clickable-card>
          </router-link>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
// import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'
import stores from '@/stores'
export default {
  name: 'amsConfiguration',
  components: { ClickableCard },
  data () {
    return {
      isSuperAdmin: false,
      AMS_ZonalManager: false,
      userEmailId: ''
    }
  },
  created: async function () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    this.userEmail = userStore.userInfo.email

    if (this.isSuperAdmin === false) {
      for (const item of userStore.roles) {
        if (item.role === 'AMS_ZonalManager') {
          this.AMS_ZonalManager = true
        }
        if (item.role === 'AMSCycleConfiguration') {
          this.AMS_CycleConfiguration = true
        }
        if (item.role === 'AMSWeightageModification') {
          this.AMS_WeightageModification = true
        }
      }
    }
  }
}
</script>

<style scoped>

.rowClass {
  margin-top: 20px;
  margin-bottom: 20px;
}
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 25px;
}

.flex-item {
  flex: 1;
  padding: 10px;
  background-color: lightblue;
  text-align: center;
  min-width: 100px;
}
</style>
